// extracted by mini-css-extract-plugin
export default {"shopBtn":"ShopBtn_shopBtn__fOEG1"};